import { render, staticRenderFns } from "./ReceivedComponent.vue?vue&type=template&id=8b1c7c3a&"
import script from "./ReceivedComponent.vue?vue&type=script&lang=ts&"
export * from "./ReceivedComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ReceivedComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports